import { render } from "./Sprite.vue?vue&type=template&id=b1bb8996&bindings={\"width\":\"props\",\"height\":\"props\",\"sprite\":\"props\",\"fx\":\"props\",\"fy\":\"props\",\"index\":\"props\",\"measure\":\"props\",\"styleObject\":\"options\"}"
import script from "./Sprite.vue?vue&type=script&lang=js"
export * from "./Sprite.vue?vue&type=script&lang=js"
script.render = render

export default script